module.exports = __webpack_public_path__ + "img/257192aprendum.02b9f153.jpg";